import { useState, useEffect, useCallback } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router';

type WindowWithNavigation = Window & {
  allowNavigation?: () => void;
};

export const useStepNavigation = () => {
  const params = useParams();
  const { step } = params;
  const location = useLocation();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState<number>(1);

  useEffect(() => {
    setActiveStep(step ? parseInt(step) : 1);
  }, [step]);

  const setActiveStepProxy = useCallback(
    (newStep: number) => {
      setActiveStep(newStep);
      const currentStep = step ? parseInt(step) : 1;
      if (currentStep !== newStep) {
        (window as WindowWithNavigation).allowNavigation?.();
        const { id } = params;
        if (id) {
          navigate(location.pathname.replace(`/${step}/${id}`, `/${newStep}/${id}`));
        } else {
          navigate(location.pathname.replace(/\/\d*[^/]$|[/]?$/, `/${newStep}`));
        }
      }
    },
    [step, params, location.pathname, navigate]
  );

  return {
    activeStep,
    setActiveStep: setActiveStepProxy
  };
};
